import { actionsTranslations } from "./actions/translations.js";
import { changePasswordTranslations } from "./change-password/translations.js";
import { commonTranslations } from "./common/translations.js";
import { confirmAccountTranslations } from "./confirm-account/translations.js";
import { dashboardTranslations } from "./dashboard/translations.js";
import { forgotPasswordTranslations } from "./forgot-password/translations.js";
import { headerTranslations } from "./header/translations.js";
import { loginTranslations } from "./login/translations.js";
import { profileTranslations } from "./profile/translations.js";
import { redirectsTranslations } from "./redirects/translations.js";
import { registerTranslations } from "./register/translations.js";
import { resendConfirmationEmailTranslations } from "./resend-confirmation-email/translations.js";
import { resetPasswordTranslations } from "./reset-password/translations.js";
import { en as authEn } from "../backend-messages/en.js";
import { es as authEs } from "../backend-messages/es.js";
import { pt as authPt } from "../backend-messages/pt.js";
export const frontendTranslations = {
    en: {
        common: commonTranslations.en,
        header: headerTranslations.en,
        auth: authEn,
        login: loginTranslations.en,
        register: registerTranslations.en,
        forgotPassword: forgotPasswordTranslations.en,
        resetPassword: resetPasswordTranslations.en,
        redirects: redirectsTranslations.en,
        dashboard: dashboardTranslations.en,
        changePassword: changePasswordTranslations.en,
        profile: profileTranslations.en,
        actions: actionsTranslations.en,
        confirmAccount: confirmAccountTranslations.en,
        resendConfirmationEmail: resendConfirmationEmailTranslations.en,
    },
    es: {
        common: commonTranslations.es,
        header: headerTranslations.es,
        auth: authEs,
        login: loginTranslations.es,
        register: registerTranslations.es,
        forgotPassword: forgotPasswordTranslations.es,
        resetPassword: resetPasswordTranslations.es,
        redirects: redirectsTranslations.es,
        dashboard: dashboardTranslations.es,
        changePassword: changePasswordTranslations.es,
        profile: profileTranslations.es,
        actions: actionsTranslations.es,
        confirmAccount: confirmAccountTranslations.es,
        resendConfirmationEmail: resendConfirmationEmailTranslations.es,
    },
    pt: {
        common: commonTranslations.pt,
        header: headerTranslations.pt,
        auth: authPt,
        login: loginTranslations.pt,
        register: registerTranslations.pt,
        forgotPassword: forgotPasswordTranslations.pt,
        resetPassword: resetPasswordTranslations.pt,
        redirects: redirectsTranslations.pt,
        dashboard: dashboardTranslations.pt,
        changePassword: changePasswordTranslations.pt,
        profile: profileTranslations.pt,
        actions: actionsTranslations.pt,
        confirmAccount: confirmAccountTranslations.pt,
        resendConfirmationEmail: resendConfirmationEmailTranslations.pt,
    },
};
//# sourceMappingURL=translations.js.map